import Typography from '@mui/material/Typography';
import i18next from 'i18next';
import * as React from 'react';

import { getFallbackLanguageLabel, getNativeLanguage, getTranslatedLanguage } from '../utils/SettingsUtils';

import { isNotNullOrEmpty } from '@easterngraphics/wcf/modules/utils/string';

const LanguageComponent: React.FC<{ locale: string }> = (props) => {
    const { locale } = props;
    return (
        <React.Fragment>
            <Typography display="inline">{getTranslatedLanguage(locale)} - </Typography>
            <Typography display="inline" sx={{ color: 'text.secondary' }}>{getNativeLanguage(locale)}</Typography>
        </React.Fragment>
    );
};

export function languageToLabelComponent(value: string | undefined): React.ReactNode {
    if (isNotNullOrEmpty(value)) {
        try {
            return <LanguageComponent locale={value}/>;
        } catch {
            return getFallbackLanguageLabel(value);
        }
    }
    return i18next.t('Unknown');
}